import { createLazyFileRoute } from "@tanstack/react-router";

import { Breadcrumb } from "@/components/ui/breadcrumbs";
import { MaterialDetailForm } from "@/features/admin/components/materials/MaterialDetailForm";
import { Section } from "@/features/admin/components/Section";

export const Route = createLazyFileRoute("/_auth/admin/materials/new")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <div className="flex flex-col flex-1 max-w-3xl">
      <Section.Title
        breadcrumb={
          <>
            <Breadcrumb href={{ to: "/admin/materials" }}>Materials</Breadcrumb>
            <Breadcrumb>New</Breadcrumb>
          </>
        }
      >
        New material
      </Section.Title>
      <MaterialDetailForm />
    </div>
  );
}
